import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { ForumPost, ApiForumPost } from '../../models/ForumPost';
import { Kyc, ApiKyc } from '../../models/Kyc';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import MyPostCard from './MyPostCard';

const DoneeForumList = () => {
  const [ posts, setPosts ] = useState<ForumPost[]>();
  const [ kyc, setKyc ] = useState<Kyc>();
  const { get, loading } = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    get({
      endpoint: 'api/v1/forum_posts/mine',
      onSuccess: (res) => {
        setPosts((res.data as ApiForumPost[]).map(p => new ForumPost(p)));
      },
      onError: () => { toast.error('投稿の取得に失敗しました'); },
    });
  }, [ get ]);

  useEffect(() => {
    get({
      endpoint: '/api/v1/kycs/me',
      onSuccess: (data) => { setKyc(new Kyc(data.data as ApiKyc)); },
    });
  }, [ get ]);

  const handleNewPost = () => {
    if (!kyc || ![ 'AUTO_CERTIFIED', 'MAN_CERTIFIED' ].includes(kyc.status)) {
      toast.error('本人確認を行なってください');
      return;
    }
    navigate('/mypage/forum/new');
  };

  const handleUpdated = (id: number, updated: ApiForumPost) => {
    setPosts(prev => prev?.map(p => p.id === id ? new ForumPost(updated) : p));
  };

  if (loading || !posts) return <Spinner centered={ true } color="pink" />;

  const hasActivePost = posts.some(p =>
    p.isDraft || (p.isOpen && (!p.expiresAt || new Date(p.expiresAt) >= new Date()))
  );

  return (
    <section className="donee_forum pink">
      <h2 className="main_title"><span>募集掲示板の管理</span><Link to="/forum" className="forum_link">掲示板を見る</Link></h2>
      { hasActivePost ? (
        <span className="pinkbtn" style={ { opacity: 0.45, cursor: 'not-allowed' } }>新規投稿</span>
      ) : (
        <span className="pinkbtn" style={ { cursor: 'pointer' } } onClick={ handleNewPost }>新規投稿</span>
      ) }
      { posts.length === 0 ? (
        <p className="mp-empty">投稿がありません。</p>
      ) : (
        <ul className="mp-list">
          { posts.map(post => (
            <MyPostCard
              key={ post.id }
              post={ post }
              onUpdated={ handleUpdated }
            />
          )) }
        </ul>
      ) }
    </section>
  );
};

export default DoneeForumList;
